module.exports = __webpack_public_path__ + "static/media/fj.76a7a39e.svg";